import { isNil, has } from 'lodash';

import { createToast, toastType } from 'Common/ToastHelper';
import { TitleEnum } from 'Common/Constants/Enumeration/CommonEnum';
import { loading, error, handleErrorException, success } from 'State/actions';

import * as types from './types';
import { redirectFromHub } from '../hub/actions';

export const getActiveApplication = pageObj => {
  return async (dispatch, getState, MPWWebApi) => {
    try {
      const {
        ManageApplicationState: {
          manageApplication: { applicationFilters },
        },
      } = getState();

      pageObj = { ...applicationFilters, ...pageObj };

      dispatch(
        loading(types.MANAGE_APPLICATION_ACTIVE_APPLICATIONS_LOADING, true)
      );

      const response = await MPWWebApi.postGenericInsertUpdate(
        'Application/Type',
        pageObj
      );

      dispatch({
        type: types.ACTIVE_APPLICATION_GET_STUDENTS,
        payload: {
          data: response.data,
          type: pageObj.ApplicationType,
        },
      });

      dispatch(
        loading(types.MANAGE_APPLICATION_ACTIVE_APPLICATIONS_LOADING, false)
      );
    } catch (error) {
      dispatch({
        type: types.ACTIVE_APPLICATION_GET_STUDENTS_ERROR,
        payload: error.response,
      });

      dispatch(
        loading(types.MANAGE_APPLICATION_ACTIVE_APPLICATIONS_LOADING, false)
      );
      if (
        has(error, 'response.data.Errors') &&
        error.response.data.Errors[0] &&
        error.response.data.Errors[0].Title !== null
      ) {
        error.response.data.Errors.map((errorValue, i) => {
          createToast(
            toastType.error,
            errorValue[i].Title,
            errorValue[i].Message
          );
          return null;
        });
      } else {
        createToast(
          toastType.error,
          'Error',
          'Unable to load student details',
          true
        );
      }
    }
  };
};

export const getAvailableToDecline = () => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.MANAGE_APPLICATION_LOADING, true));
    try {
      const statusResponse = await MPWWebApi.getGeneric(
        `Verification/GetAvailableToDecline`
      );

      if (
        statusResponse &&
        statusResponse.data &&
        !isNil(statusResponse.data.Data)
      ) {
        dispatch({
          type: types.MANAGE_APPLICATION_AVAILABLE_TO_DECLINE,
          payload: statusResponse.data.Data,
        });
      }
    } catch (ex) {
      dispatch(error(types.ACTIVE_APPLICATION_GET_STUDENTS_ERROR, ex));
    }
    dispatch(loading(types.MANAGE_APPLICATION_LOADING, false));
  };
};

export const declineToVerify = householdId => {
  return async (dispatch, getState, MPWWebApi) => {
    const {
      ManageApplicationState: {
        manageApplication: { applicationFilters },
      },
    } = getState();
    dispatch(loading(types.MANAGE_APPLICATION_LOADING, true));
    try {
      const statusResponse = await MPWWebApi.getGeneric(
        `Verification/WriteDeclineToVerify/${householdId}`
      );

      if (statusResponse.status === 200) {
        createToast(
          toastType.success,
          'Success',
          'Application successfully declined for verification.'
        );
        dispatch(getAvailableToDecline());
        dispatch(getActiveApplication(applicationFilters));
      }
    } catch (ex) {
      dispatch(error(types.ACTIVE_APPLICATION_GET_STUDENTS_ERROR, ex));
      createToast(
        toastType.error,
        'Error',
        'Unable to replace application for verification.',
        true
      );
    }
    dispatch(loading(types.MANAGE_APPLICATION_LOADING, false));
  };
};

export const deleteApplication = (
  familyId,
  deleteStudents,
  filtered,
  redirect
) => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.MANAGE_APPLICATION_LOADING, true));

    try {
      await MPWWebApi.postGenericInsertUpdate('Application/Delete', {
        FamilyId: familyId,
        DeleteStudents: deleteStudents,
      });

      createToast(
        toastType.success,
        'Success',
        'Application deleted successfully.'
      );

      if (redirect) {
        dispatch(redirectFromHub());
      }
    } catch (error) {
      createToast(
        toastType.error,
        'Error',
        'Unable to delete application',
        true
      );
    }
    dispatch(loading(types.MANAGE_APPLICATION_LOADING, false));
    dispatch(getActiveApplication(filtered));
  };
};

export const saveFilters = obj => {
  return (dispatch, getState, MPWWebApi) => {
    const {
      ManageApplicationState: { applicationFilters },
    } = getState();

    obj = { ...applicationFilters, ...obj };

    dispatch({
      type: types.ACTIVE_APPLICATION_SAVE_FILTERS,
      payload: obj,
    });
  };
};

export const printLetterByFamilyId = systemId => {
  return async (dispatch, getState, MPWWebApi) => {
    try {
      dispatch(loading(types.MANAGE_APPLICATION_LOADING, true));

      await MPWWebApi.getGeneric(
        `Letter/GetNotificationOrDCLetterBySystemId/${systemId}`
      );

      dispatch(success(types.MANAGE_APPLICATION_REPRINTED_SUCCESSFULLY));
    } catch (ex) {
      const defaultError = {
        Title: TitleEnum.Error,
        Message:
          'An error occurred while reprinting the letter. Please try again',
      };
      dispatch(
        handleErrorException(
          ex,
          types.ACTIVE_APPLICATION_GET_STUDENTS_ERROR,
          defaultError
        )
      );
    } finally {
      dispatch(loading(types.MANAGE_APPLICATION_LOADING, false));
    }
  };
};

export const clearError = () => {
  return {
    type: types.ACTIVE_APPLICATION_CLEAR_ERROR,
  };
};

export const resetReprintedFlag = () => {
  return {
    type: types.ACTIVE_APPLICATION_RESET_REPRINT_FLAG,
  };
};

export const setAutoPopulateStudentData = studentData => ({
  type: types.MANAGE_APPLICATION_SET_AUTO_POPULATE_STUDENT_DATA,
  payload: studentData,
});



// WEBPACK FOOTER //
// ./src/pages/manageapplication/state/manageapplication/actions.js